import { Component, OnInit, Inject, OnDestroy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Store, select } from "@ngrx/store";
import { userDetailsPayload } from "src/app/app-store/user/user.selector";
import { Subscription } from "rxjs";

@Component({
  selector: "app-bannerpreviewdialog",
  templateUrl: "./bannerpreviewdialog.component.html",
  styleUrls: ["./bannerpreviewdialog.component.css"],
})
export class BannerpreviewdialogComponent implements OnInit, OnDestroy {
  mobileImage = "assets/images/checkout_mobile_img.png";
  desktopImage = "assets/images/checkout_img.png";
  userDetailSubscription: Subscription;
  imageLoading = true;

  constructor(
    private dialogRef: MatDialogRef<BannerpreviewdialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.userDetailSubscription = this.store
      .pipe(select(userDetailsPayload))
      .subscribe((response) => {
        if (response.preferredLanguage !== "English") {
          this.mobileImage = "assets/images/checkout_mobile_img.png";
          this.desktopImage = "assets/images/checkout_img.png";
        }
      });
  }

  close = () => {
    this.dialogRef.close(true);
  };

  setLoaded() {
    this.imageLoading = false;
  }

  ngOnDestroy() {
    if (this.userDetailSubscription) {
      this.userDetailSubscription.unsubscribe();
    }
  }
}
